import UploadFileProgressComponent from './UploadFileProgressComponent';
export default UploadFileProgressComponent;
